module.exports = __webpack_public_path__ + "static/img/equipmentu4.2383ab32.webp";